import { LoanLedger } from './LoanLedger';
import { FAMILY_LOAN_CONFIG, FAMILY_LOAN_SLUG } from './loan-configs';

/**
 * Family loan ledger. Terms live in `loan-configs.ts` so the Debt
 * Balances rollup and this ledger always agree on the numbers.
 */
export function FamilyLoanPage() {
  return (
    <LoanLedger
      config={FAMILY_LOAN_CONFIG}
      slug={FAMILY_LOAN_SLUG}
    />
  );
}
